import React from 'react'
import { createSearchParams, useNavigate } from 'react-router-dom'

import { Box, Card, Icon } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import { i18nDateToString } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

interface ActionCardProps {
  icon: React.ComponentProps<typeof Icon.Large>['icon']
  title: string
  description: string
  onClick: () => void
}

const ActionCard: React.FC<ActionCardProps> = ({ icon, title, description, onClick }) => {
  return (
    <Card onClick={onClick}>
      <Card.Eyebrow>
        <Icon.Large icon={icon} color="radicalRed1000" />
      </Card.Eyebrow>
      <Card.Title>{title}</Card.Title>
      <Card.Description>{description}</Card.Description>
    </Card>
  )
}

export const SelectCreateReviewModal: React.FC<{ onClose?: () => void }> = ({ onClose }) => {
  const navigate = useNavigate()

  const trackEvent = (reviewType: 'blank' | 'template') => {
    track(trackingEvents.performanceProcess.createReviewStarted, {
      review_type: reviewType,
      start_date: i18nDateToString(new Date(), 'backend'),
    })
  }

  return (
    <Modal
      illustration="user-performance"
      title={i18n.t('performance_process.reviews.create.selection_modal.title')}
      description={i18n.t('performance_process.reviews.create.selection_modal.description')}
      onClose={() => onClose?.()}
      disableFocusTrap
    >
      <Box
        flexDirection="row"
        gap="s24"
        style={{ width: 'calc(100vw - 60vw)' }}
        maxWidth="sidepanelWideXL"
      >
        <Box style={{ flex: '1' }}>
          <ActionCard
            icon="custom-file"
            title={i18n.t(
              'performance_process.reviews.create.selection_modal.action_card.scratch_title'
            )}
            description={i18n.t(
              'performance_process.reviews.create.selection_modal.action_card.scratch_description'
            )}
            onClick={() => {
              trackEvent('blank')
              navigate({
                search: createSearchParams({ modal: 'new' }).toString(),
              })
            }}
          />
        </Box>
        <Box style={{ flex: '1' }}>
          <ActionCard
            icon="template"
            title={i18n.t(
              'performance_process.reviews.create.selection_modal.action_card.template_title'
            )}
            description={i18n.t(
              'performance_process.reviews.create.selection_modal.action_card.template_description'
            )}
            onClick={() => {
              trackEvent('template')
              navigate({
                search: createSearchParams({ modal: 'newFromTemplate' }).toString(),
              })
            }}
          />
        </Box>
      </Box>
    </Modal>
  )
}
